import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'
// import classnames from 'classnames';
import _ from 'lodash'

import config from '../../../../../../../../../config'

import hocBlock from '../../../../../../../components/Workspace/components/HocBlock'

import Summary from './components/Summary'
import Partners from './components/Partners'

import { LOCALE_PREFIX } from './constants'
import hocConnect from './hocConnect'
import './style.scss'

@hocBlock(config.modules.report.key, { levelReload: true })
@hocConnect
@injectIntl
export default class BusinessPartners extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        customData: PropTypes.object,
        data: PropTypes.array,
        id: PropTypes.string.isRequired,
        intl: PropTypes.object,
        level: PropTypes.string,
        locale: PropTypes.string.isRequired,
        module: PropTypes.string.isRequired,
        openLinkagesById: PropTypes.func.isRequired,
    }

    render() {
        const { block, id, level, locale, module, data, intl, customData, openLinkagesById } = this.props

        return (
            <div className={'business-partners-block-container'}>
                <Summary
                    block={block}
                    id={id}
                    data={_.get(data, '[0]', {})}
                    level={level}
                    locale={locale}
                    module={module}
                />
                <Partners block={block} id={id} level={level} locale={locale} module={module} customData={customData} />
                <div className={'info-msg'}>
                    <FormattedMessage
                        id={`${LOCALE_PREFIX}.linkagesDetail`}
                        values={{
                            link: (
                                <button onClick={() => openLinkagesById(id)} className={'detail-btn'}>
                                    {intl.formatMessage({ id: `${LOCALE_PREFIX}.linkages` })}
                                </button>
                            ),
                        }}
                    />
                </div>
            </div>
        )
    }
}
